import { CommonDashboardReport } from '@home/components/CommonDashboardReport';
import React from 'react'; 

export default function DashboardReport({
  id,
  className,
  pageName, 
  pageId,
}: {
  id: string;
  className?: string;
  pageName: string; 
  pageId: string;
}) {
  return (
    <CommonDashboardReport
      dashboardId={id}
      system={'opinion_pc_v2'}
      className={className}
      reportInfo={{
        reportPageId: pageId,
        typeId: 'opinion_pc_v2',
        dashboardId: id,
        pageName,
        source: 2
      }}
    />
  );
}
 